<template>
    <!-- 诗词页面 -->
    <div class="poem-page">
        <!-- 头部 -->
        <Header/>
        <!-- 诗词列表 -->
        <PoemList/>
    </div>
</template>

<script>
    // 使用命名空间之后的简化方式
    import {createNamespacedHelpers } from "vuex";
    const { mapState, mapMutations } = createNamespacedHelpers('nav');
    import Header from './children/Header';
    import PoemList from './children/PoemList';
    export default {
        name: "PoemPage",
        created(){
            // TODO 1.被创建时指定当前导航栏类型为普通类型
            this.typeUpdate(2);
        },
        methods:{
            ...mapMutations(['typeUpdate'])
        },
        components:{
            Header,
            PoemList
        }
    }
</script>

<style scoped lang="less">
    .poem-page{
        margin-top: 83px;
    }
</style>